// extracted by mini-css-extract-plugin
module.exports =  {"container":"_2787e5dfdf--container--d6kg0","text":"_2787e5dfdf--text--AaPLM"};